function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-24x24-Request",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,0 C16.3062521,0 17.4175144,0.834850101 17.8293257,2.00008893 L19,2 C20.6568542,2 22,3.34314575 22,5 L22,5 L22,21 C22,22.6568542 20.6568542,24 19,24 L19,24 L5,24 C3.34314575,24 2,22.6568542 2,21 L2,21 L2,5 C2,3.34314575 3.34314575,2 5,2 L5,2 L6.17067428,2.00008893 C6.58248558,0.834850101 7.69374794,0 9,0 L9,0 Z M19,4 L5,4 C4.44771525,4 4,4.44771525 4,5 L4,5 L4,21 C4,21.5522847 4.44771525,22 5,22 L5,22 L19,22 C19.5522847,22 20,21.5522847 20,21 L20,21 L20,5 C20,4.44771525 19.5522847,4 19,4 L19,4 Z M15,16 C15.5522847,16 16,16.4477153 16,17 C16,17.5522847 15.5522847,18 15,18 L9,18 C8.44771525,18 8,17.5522847 8,17 C8,16.4477153 8.44771525,16 9,16 L15,16 Z M15,12 C15.5522847,12 16,12.4477153 16,13 C16,13.5522847 15.5522847,14 15,14 L9,14 C8.44771525,14 8,13.5522847 8,13 C8,12.4477153 8.44771525,12 9,12 L15,12 Z M13,8 C13.5522847,8 14,8.44771525 14,9 C14,9.55228475 13.5522847,10 13,10 L11,10 C10.4477153,10 10,9.55228475 10,9 C10,8.44771525 10.4477153,8 11,8 L13,8 Z",
  id: "Combined-Shape",
  fill: "#60CAA8",
  fillRule: "nonzero"
}));

var SvgOrder = function SvgOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/order.562d69cc.svg";
export { ForwardRef as ReactComponent };